var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plain-text-primary-motion-text-display"},[_c('span',[_vm._v("   "+_vm._s(_vm.motion.content)+"   ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }